import React, { Component } from 'react';
import { ServiceLogin } from "../../service/Login";
import { ServiceMessage } from "../../service/Message";
import { ComponentsAppSplash } from "../../components/App/Splash";
import { Messages } from 'primereact/messages';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';

class ScreensAdminLogin extends Component {




    constructor() {
        super();
        this.state = {
            splash: false,
            erroLogin: false,
            usuario: "",
            senha: ""
        };

        this.serviceLogin = new ServiceLogin();
    }

    handleLoginClick() {
        const { usuario, senha } = this.state;

        if (!usuario || !senha) {
            this.setState({ erroLogin: true });
            return;
        }

        this.setState({erroLogin: false, loadingLogin: true });

        this.handleExecute({ usuario, senha });
    }


    async handleExecute(e) {
        try {
            // 🔹 aqui você pode chamar o mesmo método de login que já existe
            const response = await this.serviceLogin.login(e.usuario, e.senha);

            if (response.Irrestrito !== true) {
                this.setState({ erroLogin: true });
                ServiceMessage.warn("Usuário sem permissão de administrador.");
                ServiceLogin.logout();
                return;
            }

            // Salva sessão
            sessionStorage.setItem("adminAuth", JSON.stringify(response));
            sessionStorage.setItem("perfil", response.Perfil);

            // Redireciona para config
            window.location = "#/admin/config";
        } catch (err) {
            console.error("Erro no login admin:", err);
            this.setState({ erroLogin: true });
            ServiceMessage.warn("Usuário ou senha inválidos.");
        } finally {
            this.setState({ splash: false, loadingLogin: false });
        }
    }



    render() {
        return (
            <div style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f8f9fa"
            }}>
                <ComponentsAppSplash visible={this.state.splash} />
                <Messages ref={(el) => this.messages = el} />

                <div
                    style={{
                        width: "34.5vi",
                        height: "300px",
                        padding: "30px",
                        borderRadius: "12px",
                        background: "#fff",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                    }}>

                    <div className="login-page__form--loginAdmin">
                        <div>
                            <div style={{ marginTop: '10px' }}>
                                <label className="login-page__label">Usuário:</label>
                            </div>
                            <InputText
                                id="textLogin"
                                className={`login-page__input--loginAdmin ${this.state.erroLogin ? 'login-page__input--login--error' : ''}`}
                                value={this.state.usuario}
                                onChange={(e) => this.setState({ usuario: e.target.value })}
                            />
                        </div>

                        <div>
                            <div style={{ marginTop: '20px', position: 'relative' }}>
                                <label className="login-page__label">Senha:</label>
                            </div>
                            <span
                                className={this.state.erroLogin ? 'login-page__control--password' : ''}>
                                <Password
                                    className="login-page__input--password--loginAdmin"
                                    id="senha"
                                    value={this.state.senha}
                                    onChange={(e) => this.setState({ senha: e.target.value })}
                                    feedback={false}
                                    toggleMask

                                />
                                {this.state.erroLogin && (
                                    <p className="login-page__error-message">Prontuário ou senha inválidos.</p>
                                )}
                            </span>
                        </div>

                        <div className="login-page__button--loginAdmin">
                            <Button
                                id="btnLogin"
                                className="btn-alinhado--loginAdmin"
                                onClick={() => this.handleLoginClick()}
                                disabled={this.state.loadingLogin}
                            >
                                {this.state.loadingLogin ? (
                                    <>
                                        <i className="pi pi-spin pi-spinner login-btn-icon" style={{ marginRight: '8px' }} />
                                        Carregando...
                                    </>
                                ) : (
                                    <>
                                        <span>Acessar exames</span>
                                        <i className="pi pi-angle-right icone-do-botao" />
                                    </>
                                )}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ScreensAdminLogin;
